module.exports = __webpack_public_path__ + "static/media/top5-buenos-aires.cda9f6c8.md";